<template>
  <Wrapper :styleList="wrapperStyle" @openEditor="$emit('openEditor')">
    <div class="carousel-container">
      <el-carousel :interval="carouselInterval" arrow="always" :height="height">
        <el-carousel-item v-for="(item, index) in backgroudImages" :key="index">
          <img class="item-container" :src="item" />
        </el-carousel-item>
      </el-carousel>
      <div class="content-container">
        <div class="title" :class="!title && 'no-wrapper'">{{ title }}</div>
        <div class="title sub-title" :class="!subTitle && 'no-wrapper'">{{ subTitle }}</div>
        <div v-if="isShowSearchBox" class="search-box">
          <el-input class="search-ipt" v-model="keywords" :placeholder="$t('microSite.carousel.placeHolder.enterJobKeywords')"></el-input>
          <el-button class="search-btn" type="primary" @click="onSearchButtonClick">{{ $t('microSite.carousel.btn.searchJob') }}</el-button>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import Wrapper from '../../components/render/wrapper'
import RenderMixin, { SIZE_TYPE } from '../renderMixin'

export default {
  components: {
    Wrapper
  },
  mixins: [RenderMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    isAutoImageHeight: {
      type: Boolean,
      required: false
    },
    imageHeight: {
      type: String,
      required: false
    },
    backgroudImages: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShowSearchBox: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 5000
    }
  },
  data () {
    return {
      hasMounted: false,
      keywords: ''
    }
  },
  computed: {
    ...mapGetters('microSite', ['isMobile', 'isEditMode']),
    wrapperStyle () {
      return {
        width: this.width
      }
    },
    height () {
      let height
      const config = this.size?.height
      const type = config?.type
      if (type === SIZE_TYPE.FIXED) {
        height = `${config.fixed}`
        if (!height.includes('px')) {
          height += 'px'
        }
      } else if (type === SIZE_TYPE.SCREEN_PERCENTAGE) {
        height = `${config.percentage}vh`
      } else {
        // type === SIZE_TYPE.AUTO
        height = '584px'
        if (this.isMobile && this.hasMounted) {
          height = `${(this.$el.clientWidth || window.innerWidth) * 500 / 375}px`
        }
      }
      return height
    },
    carouselInterval () {
      return this.interval || 5000
    }
  },
  created () {

  },
  mounted () {
    this.hasMounted = true
  },
  methods: {
    onSearchButtonClick () {
      // TODO
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .carousel-container {
    position: relative;

    .item-container {
      display: block;
      width: 100%;
      height: 100%;
    }

    .content-container {
      text-align: center;
      position: absolute;
      width: 100%;
      top: 50%;
      transform: translate(0, -50%);
      z-index: 2;

      .title {
        color: white;
        font-weight: bold;
        font-size: 36px;
        line-height: 48px;
        width: 54%;
        margin: 8px auto;
        text-shadow: 0 2px 4px rgba(0,0,0,0.5);
      }

      .sub-title {
        font-size: 20px;
        line-height: 20px;
      }

      .search-box {
        display: flex;
        margin: auto;
        width: 54%;

        .search-ipt {
          ::v-deep .el-input__inner {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }

        .search-btn {
          background-color: rgb(0, 209, 219);
          border-color: rgb(0, 209, 219);
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
  }
}

.site-mobile {

}

.site-pc {
  .carousel-container {
    width: 100%;
  }
}
</style>
